<template>
  <div>
    <!-- 全部时间  -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" width="1082px" center>
      <div class="content">

        <el-table :data="node_list" :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" border>

          <!--  入金时间-->
          <el-table-column align="center" label="入金时间" width="100">
            <template slot-scope="scope">
              {{ setTime('已支付待确认到账', scope.row) }}
            </template>
          </el-table-column>
          <!--  入金确认时间-->
          <el-table-column align="center" label="入金确认时间" width="100">
            <template slot-scope="scope">
              {{ setTime('已到账待采购', scope.row) }}
            </template>
          </el-table-column>
          <!--  标记待改价-->
          <el-table-column align="center" label="标记待改价" width="100">
            <template slot-scope="scope">
              {{ setTime('提交到待改价', scope.row) }}
            </template>
          </el-table-column>
          <!--  财务付款时间-->
          <el-table-column align="center" label="财务付款时间" width="100">
            <template slot-scope="scope">
              {{ setTime('待发货', scope.row) }}
            </template>
          </el-table-column>
          <!--   商品发货时间 -->
          <el-table-column align="center" label="商品发货时间" width="100">
            <template slot-scope="scope">
              {{ setTime('已发货', scope.row) }}
            </template>
          </el-table-column>
          <!--   商品收货时间 -->
          <el-table-column align="center" label=" 商品收货时间 " width="100">
            <template slot-scope="scope">
              {{ setTime('已签收（收货员扫描物流号）', scope.row) }}
            </template>
          </el-table-column>
          <!--  开始核查时间-->
          <el-table-column align="center" label="开始核查时间" width="100">
            <template slot-scope="scope">
              {{ setTime('核查中（拆包时间）', scope.row) }}
            </template>
          </el-table-column>
          <!--  开始检品时间 -->
          <el-table-column align="center" label="开始检品时间 " width="100">
            <template slot-scope="scope">
              {{ setTime('检品中', scope.row) }}
            </template>
          </el-table-column>
          <!--  检品完了时间 -->
          <el-table-column align="center" label="检品完了时间 " width="100">
            <template slot-scope="scope">
              {{ setTime('检品完了', scope.row) }}
            </template>
          </el-table-column>
          <!--  上架完了时间-->
          <el-table-column align="center" label="上架完了时间" prop="inspect_at" width="100">
            <template slot-scope="scope">
              {{ setTime('上架完了', scope.row) }}
            </template>
          </el-table-column>

          <!--  问题产品-->
          <!-- <el-table-column align="center" label="问题产品" prop="inspect_at" width="100">
          </el-table-column> -->
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    node_list: { type: Array },
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    // 从时间列表中查找出对应的时间
    setTime(type, node_list) {
      let returnData = node_list.find((listItem) => {
        return listItem.name == type;
      });
      return (returnData || {}).datetime;
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  // display: flex;


}
</style>